import moment from 'moment';
import { checkCircleSVG, errorCircleSVG } from '../../shared/helpers/icons';
import { buildDevice } from './devices';
import { buildSimcard } from './simcards';

export const buildGps_devices = (gps_devices) => gps_devices.map((gps_device => buildGps_device(gps_device)));

const buildGps_device = (gps_device) => ({
    ...gps_device,
    created: moment(gps_device.created).format("DD-MM-YYYY"),
    simcard: Array.isArray(gps_device.simcard) && typeof gps_device.simcard[0] !== 'undefined'  ? buildSimcard(gps_device.simcard[0]) : gps_device.simcard,
    device: Array.isArray(gps_device.device) && typeof gps_device.device[0] !== 'undefined'  ? buildDevice(gps_device.device[0]) : gps_device.device,
    status: (Array.isArray(gps_device.status) ? gps_device.status[0] : gps_device.status) || {},
    enabledIcon: gps_device.enabled ? checkCircleSVG : errorCircleSVG
});

export const checkErrors = errors => errors.filter(err => !err.success);